// src/pages/ForRent.jsx
import React from 'react';
import PropertyListingPage from '../PropertyListing/PropertyListing';
import { Helmet } from 'react-helmet';

const ForRent = () => {
  return (
    <>      <Helmet>
            <title>For Rent</title>
            <meta name="description" content="Welcome to Gladious – experts in sustainable and modern construction projects." />
          </Helmet>
  <PropertyListingPage filterType="for-rent" pageTitle="Properties For Rent"/>;
</>
  )
};

export default ForRent;
